module.exports = __webpack_public_path__ + "img/s-1.36e64175.png";